var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"enlargeChart",staticClass:"chart-container",style:({width: '100%',height: _vm.height || '300px'}),attrs:{"id":"enlargeChart"}})}
var staticRenderFns = []

export { render, staticRenderFns }